import { ScreenInsightsLiveKiosk } from '@dms/screen'

export default ScreenInsightsLiveKiosk
